// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TLCHpUpSClYqtpPX9ubp {
  background-color: transparent;
}

.pYURZgIlOl8EQYdMEYrw {
  position: relative;
  z-index: 1;
  background-color: var(--header-background);
  box-shadow: 0 0.25rem 0.75rem var(--black-012);
}

.oDNnU0_q7pbxyjb_HemR {
  text-align: center;
  padding: 0.625rem 0;
}

.XA_vBioXLc8qfN5Tqzwz {
  background: var(--header-background);
  height: 5rem;
  max-width: var(--content-column);
  margin: 0 auto;
  padding: 0.875rem var(--content-padding);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.jWS1b6roXyOzT2SmmQL3,
.r1HCdCirxAKC5WISYGvg,
.rj9xlEroeCvElAX2YKKQ {
  display: flex;
  align-items: center;
}

.dbQlHjEs0Qjn1MK7h0Rj {
  width: 12.5rem;
  margin-top: 0.125rem;
}

.HzvXrjtth2DSAmYKNODN {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  height: 100%;
  background-color: var(--header-background);
}

.bbGhCt0onbGgYBO0bX0n {
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 0.75rem;
}

.WlohvNurx0uCxD2KJjEF {
  cursor: pointer;
}

._yqNARnD4XrczqwBeDUR {
  color: var(--secondary-link-color);
}

.ADVgEGB8qVUNHawxhnjp {
  color: var(--redeem-header-font-color);
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .XA_vBioXLc8qfN5Tqzwz {
    padding: 0.75rem var(--content-padding-desktop-small);
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .XA_vBioXLc8qfN5Tqzwz {
    padding: 0.75rem var(--content-padding-tablet);
  }

  .dbQlHjEs0Qjn1MK7h0Rj {
    width: 10.625rem;
  }

  .HzvXrjtth2DSAmYKNODN {
    background-color: var(--grey-100);
  }
}

@media only screen and
  (max-width: 639px) {
  .HzvXrjtth2DSAmYKNODN {
    background-color: var(--grey-100);
  }

  .XA_vBioXLc8qfN5Tqzwz {
    padding: 0.75rem var(--content-padding-mobile);
  }

  .dbQlHjEs0Qjn1MK7h0Rj {
    width: 10.625rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RedeemHeader/RedeemHeader.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0CAA0C;EAC1C,8CAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,mBAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,wCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAY;EACZ,oBAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAW;EACX,cAAY;EACZ,oBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;EACE;IACE,qDAAkD;EACpD;AACF;;AAEA;;;EACE;IACE,8CAA2C;EAC7C;;EAEA;IACE,gBAAY;EACd;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,8CAA2C;EAC7C;;EAEA;IACE,gBAAY;EACd;AACF","sourcesContent":[".rootContainer {\n  background-color: transparent;\n}\n\n.header {\n  position: relative;\n  z-index: 1;\n  background-color: var(--header-background);\n  box-shadow: 0 4px 12px var(--black-012);\n}\n\n.delayWarning {\n  text-align: center;\n  padding: 10px 0;\n}\n\n.headerContent {\n  background: var(--header-background);\n  height: 80px;\n  max-width: var(--content-column);\n  margin: 0 auto;\n  padding: 14px var(--content-padding);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.leftSide,\n.rightSide,\n.rightNavIcons {\n  display: flex;\n  align-items: center;\n}\n\n.logo {\n  width: 200px;\n  margin-top: 2px;\n}\n\n.headerMenuWrapper {\n  display: flex;\n  flex-direction: column;\n  overflow-x: auto;\n  height: 100%;\n  background-color: var(--header-background);\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n  margin-left: 12px;\n}\n\n.link {\n  cursor: pointer;\n}\n\n.textClassName {\n  color: var(--secondary-link-color);\n}\n\n.customerSupport {\n  color: var(--redeem-header-font-color);\n}\n\n@media (--desktop-small) {\n  .headerContent {\n    padding: 12px var(--content-padding-desktop-small);\n  }\n}\n\n@media (--tablet) {\n  .headerContent {\n    padding: 12px var(--content-padding-tablet);\n  }\n\n  .logo {\n    width: 170px;\n  }\n\n  .headerMenuWrapper {\n    background-color: var(--grey-100);\n  }\n}\n\n@media (--mobile) {\n  .headerMenuWrapper {\n    background-color: var(--grey-100);\n  }\n\n  .headerContent {\n    padding: 12px var(--content-padding-mobile);\n  }\n\n  .logo {\n    width: 170px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootContainer": `TLCHpUpSClYqtpPX9ubp`,
	"header": `pYURZgIlOl8EQYdMEYrw`,
	"delayWarning": `oDNnU0_q7pbxyjb_HemR`,
	"headerContent": `XA_vBioXLc8qfN5Tqzwz`,
	"leftSide": `jWS1b6roXyOzT2SmmQL3`,
	"rightSide": `r1HCdCirxAKC5WISYGvg`,
	"rightNavIcons": `rj9xlEroeCvElAX2YKKQ`,
	"logo": `dbQlHjEs0Qjn1MK7h0Rj`,
	"headerMenuWrapper": `HzvXrjtth2DSAmYKNODN`,
	"icon": `bbGhCt0onbGgYBO0bX0n`,
	"link": `WlohvNurx0uCxD2KJjEF`,
	"textClassName": `_yqNARnD4XrczqwBeDUR`,
	"customerSupport": `ADVgEGB8qVUNHawxhnjp`
};
export default ___CSS_LOADER_EXPORT___;
